import type { RefObject } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '~/components';
import { cn } from '~/lib/cn';
import { useScrollMessage } from '~/modules/artist-roster/components/ArtistContactInfo/hooks/useScrollMessage';

interface ScrollMessageProps {
  scrollRef: RefObject<HTMLDivElement>;
}

export function ScrollMessage({ scrollRef }: ScrollMessageProps) {
  const { t } = useTranslation('roster');
  const { isScrolledToTop, isScrollMessageVisible } =
    useScrollMessage(scrollRef);

  return (
    <div
      className={cn(
        'absolute inset-x-md bottom-0',
        'pointer-events-none pb-xs text-center text-body-xs duration-300',
        'shadow-[0_-0.3rem_0.5rem_oklch(var(--bg-level-03))] bg-level-03',
        {
          '-bottom-xl opacity-none': !isScrollMessageVisible,
          'text-subtle': !isScrolledToTop,
        },
      )}
    >
      {t('contactInfo.scrollForMore')}
      <Icon type="chevrons-down" size="xs" className="ml-sm !align-baseline" />
    </div>
  );
}

ScrollMessage.displayName = 'ScrollMessage';
